/**
 * 图片展示节点 - 用于展示生成的图片（只读）
 */
import React, { memo } from 'react';
import { NodeLayout } from './NodeLayout';
import './ImageDisplayNode.css';

export const ImageDisplayNode = memo(({ id, data }) => {
  // 下载图片
  const handleDownload = async () => {
    if (!data.imageUrl) return;

    try {
      const response = await fetch(data.imageUrl);
      const blob = await response.blob();
      
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = data.fileName || 'generated-image.png';
      document.body.appendChild(a);
      a.click();
      
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('下载图片失败:', error);
    }
  };

  return (
    <NodeLayout 
      id={id} 
      type="imageDisplay" 
      title="图片展示"
      showInputHandle={true}
      showOutputHandle={true}
    >
      <div className="ImageDisplayNode-wrapper">
        {data.imageUrl ? (
          // 显示生成的图片
          <div>
            <div className="ImageDisplayNode-preview">
              <img
                src={data.imageUrl}
                alt={data.fileName || '生成的图片'}
                className="ImageDisplayNode-image"
              />
              <button
                onClick={handleDownload}
                className="ImageDisplayNode-download"
                title="下载图片"
              >
                ⬇
              </button>
            </div>
            {data.fileName && (
              <div className="ImageDisplayNode-filename">
                {data.fileName}
              </div>
            )}
            {/* 显示元数据 */}
            {data.metadata && (
              <div className="ImageDisplayNode-metadata">
                {data.metadata.size && (
                  <div>分辨率: {data.metadata.size}</div>
                )}
                {data.metadata.aspectRatio && (
                  <div>宽高比: {data.metadata.aspectRatio}</div>
                )}
              </div>
            )}
          </div>
        ) : data.fileName === '生成中...' ? (
          // 显示生成中状态
          <div className="ImageDisplayNode-status ImageDisplayNode-generating">
            <div className="ImageDisplayNode-loading" />
            <div className="ImageDisplayNode-text">生成中...</div>
          </div>
        ) : data.fileName === '生成失败' ? (
          // 显示失败状态
          <div className="ImageDisplayNode-status ImageDisplayNode-failed">
            <div className="ImageDisplayNode-error-icon">⚠</div>
            <div className="ImageDisplayNode-text">生成失败</div>
          </div>
        ) : (
          // 空状态
          <div className="ImageDisplayNode-status ImageDisplayNode-empty">
            <svg className="ImageDisplayNode-icon" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <rect x="4" y="8" width="24" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
              <circle cx="11" cy="14" r="2" fill="currentColor"/>
              <path d="M4 20 L10 16 L16 20 L24 13 L28 16" stroke="currentColor" strokeWidth="2"/>
            </svg>
            <div className="ImageDisplayNode-text">等待生成</div>
          </div>
        )}
      </div>
    </NodeLayout>
  );
});

ImageDisplayNode.displayName = 'ImageDisplayNode';

